import React, { Component } from 'react'
import algorithmsSortData from '../../data/Algorithms-Sort.json';

function getWidth() {
    var scWidth = Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth);

    if(scWidth*0.65 > 1110) {
        scWidth = 1000;
    } else {
        scWidth = scWidth*0.65;
    }

    return scWidth;
}

// Convert reference string like "1,2" or "1,2,7,9-14" to superscript format
function formatReferences(refString) {
    if (!refString || refString.trim() === "") return "";
    
    // Check if it's a date string (contains month name or GMT)
    if (refString.includes("GMT") || refString.includes("Jan") || refString.includes("Feb") || 
        refString.includes("Mar") || refString.includes("Apr") || refString.includes("May") ||
        refString.includes("Jun") || refString.includes("Jul") || refString.includes("Aug") ||
        refString.includes("Sep") || refString.includes("Oct") || refString.includes("Nov") ||
        refString.includes("Dec")) {
        return "";
    }
    
    const superscriptMap = {
        '0': '⁰', '1': '¹', '2': '²', '3': '³', '4': '⁴', '5': '⁵',
        '6': '⁶', '7': '⁷', '8': '⁸', '9': '⁹', '-': '⁻', ',': '\u02D2'
    };
    
    return refString.split('').map(char => superscriptMap[char] || char).join('');
}
  
class SortReference extends Component{

    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        if (!this.props.inline) {
            document.addEventListener("mousedown", this.handleClickOutside);
        }
    }

    componentWillUnmount() {
        if (!this.props.inline) {
            document.removeEventListener("mousedown", this.handleClickOutside);
        }
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && this.props.isHidden == "visible") {
            this.props.toggleSortReference()
        }
    }

    render() {
        const algorithmName = this.props.algorithmName || "";
        const algorithmData = algorithmsSortData[algorithmName] || { recommendations: [], references: [] };
        const recommendations = algorithmData.recommendations || [];
        const references = algorithmData.references || [];
        const isInline = this.props.inline || false;

        // Create a title from algorithm name (convert to uppercase)
        const title = algorithmName ? `${algorithmName.toUpperCase()} RECOMMENDATIONS AND REFERENCES` : "";

        const wrapperStyle = isInline 
            ? {width:"100%"} 
            : {width:getWidth(), visibility:this.props.isHidden};
        
        const wrapperClass = isInline ? "" : "floatingPDF";
        
        const cardWidth = isInline ? "100%" : getWidth();

        return(
            <div ref={this.wrapperRef} className={wrapperClass} style={wrapperStyle}>
                <style>
                    {`
                        @font-face {
                            font-family: 'Gloock';
                            src: url('/fonts/Gloock-Regular.ttf') format('truetype');
                            font-weight: normal;
                            font-style: normal;
                        }
                    `}
                </style>
                <div className="card" style={{width:cardWidth, padding:"30px 15px 15px 15px"}}>
                    {!isInline && (
                        <div style={{width:"100%"}}>
                            <button className='btn btn-primary' style={{width:"1%", float:"right", padding:"10px 30px 10px 20px"}} onClick={this.props.toggleSortReference}>X</button>
                        </div>
                    )}
                    <h2 style={{fontSize:"26px", marginTop:"10px", marginBottom:"20px", textAlign:"center", color:"#a7a9ac", fontFamily:"'Gloock', serif"}}>{title}</h2>
                    
                    {/* Recommendations Table */}
                    {recommendations.length > 0 && (
                        <div style={{marginBottom:"30px", backgroundColor:"#f2f2f2", padding:"10px", borderRadius:"0"}}>
                            <table style={{width:"100%", borderCollapse:"collapse", marginBottom:"0", border:"none"}}>
                                <thead>
                                    <tr>
                                        <th style={{border:"none", borderBottom:"1px solid #ddd", padding:"10px", textAlign:"center", backgroundColor:"transparent", fontWeight:"bold", width:"66.67%"}}>
                                            Recommendations with Key References
                                        </th>
                                        <th style={{border:"none", borderBottom:"1px solid #ddd", padding:"10px", textAlign:"center", backgroundColor:"transparent", fontWeight:"bold", width:"33.33%"}}>
                                            Strength of Recommendation
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {recommendations.map((rec, index) => {
                                        const formattedRefs = formatReferences(rec.references);
                                        const isLastRow = index === recommendations.length - 1;
                                        return (
                                            <tr key={rec.uid || index}>
                                                <td style={{fontSize:"16px", border:"none", borderBottom: isLastRow ? "none" : "1px solid #ddd", padding:"10px", verticalAlign:"top", width:"66.67%", backgroundColor:"transparent"}}>
                                                    {rec.recommendations}
                                                    {formattedRefs && (
                                                        <span style={{fontSize:"0.9em", marginLeft:"5px"}}>{formattedRefs}</span>
                                                    )}
                                                </td>
                                                <td style={{border:"none", borderBottom: isLastRow ? "none" : "1px solid #ddd", padding:"10px", verticalAlign:"top", textAlign:"center", width:"33.33%", backgroundColor:"transparent"}}>
                                                    <strong>{rec.strength}</strong>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* References Section */}
                    {references.length > 0 && (
                        <div style={{backgroundColor:"#f2f2f2", padding:"10px", marginTop:"20px"}}>
                            <div style={{fontWeight:"bold", marginTop:"0px", marginBottom:"12px", fontSize:"1em"}}>References</div>
                            <div style={{marginBottom:"0px"}}>
                                {references.map((ref, index) => (
                                    <div key={ref.uid || index} style={{marginBottom:"10px", lineHeight:"1.6", display:"flex"}}>
                                        <div style={{width:"30px", flexShrink:0, paddingRight:"5px", textAlign:"right"}}>
                                            {ref.uid || (index + 1)}.
                                        </div>
                                        <div style={{flex:1}}>
                                            {ref.reference || ref.link ? (
                                                <span>
                                                    {ref.reference}
                                                    {ref.date && ` (${ref.date})`}
                                                    {ref.link && (
                                                        <a href={ref.link} target="_blank" rel="noopener noreferrer" style={{marginLeft:"5px", textDecoration:"none"}}>
                                                            [Link]
                                                        </a>
                                                    )}
                                                </span>
                                            ) : (
                                                <span>{ref}</span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
    
}

export default SortReference

